import { inject, Injectable } from "@angular/core";

import type { BaseFilterDefinition, FilterOption, FilterValue } from "@filter/filter.types";
import type { JobsBillingCard, TranslateObject } from "@app/views-interfaces";
import { JobsAndBillingJobTypesService } from "@shared/jobs-and-billing-job-types-service";
import { SimpleFilterMulti } from "./types/simple-filter-multi";

@Injectable()
export class JobTypeFilterService extends SimpleFilterMulti<JobsBillingCard> {
    private readonly jobTypesService = inject(JobsAndBillingJobTypesService);
    protected noneOption: FilterOption | null = { value: null, label: "General.None" };

    protected getDefinitionInfo(): BaseFilterDefinition {
        return {
            filterName: "JobType",
            label: "AllView.JobType",
        };
    }

    protected getValue(item: JobsBillingCard): FilterValue | undefined {
        return item.job?.typeId;
    }

    protected getLabel(typeId: number): string | undefined | null | TranslateObject {
        return this.jobTypesService.jobTypes().get(typeId)?.name;
    }

    protected getAllValues(): readonly number[] {
        return Array.from(this.jobTypesService.jobTypes().keys());
    }
}
